import { axios } from "./config.js";
import type {
	TAuthVerifyCreate,
	TAuthVerifyResend,
	TAxiosGenRes,
	TBasicType,
	TForgotPass,
	TLoginParam,
	TLoginRes,
	TResetPass,
	TPostsGet,
	TUsersGet,
	TUsersAdd,
	TUsersEdit,
	TCategoriesGet,
} from "./types";

export default {
	// Auth
	authRegister: (params: any) =>
		axios.post<TAxiosGenRes<TBasicType>>("auth/register", params),
	authRenewSession: () =>
		axios.post<{ data: { data: string } }>("auth/renew-session"),
	authLogout: () => axios.get("auth/logout", { validateStatus: null }),
	authVerifyCreate: (params: TAuthVerifyCreate) =>
		axios.post<TLoginRes>("auth/verify", params),
	authVerifyResend: (params: TAuthVerifyResend) =>
		axios.put("auth/verify", params),
	authForgot: (params: TForgotPass) =>
		axios.post("auth/forgot-password", params),
	authResetPass: (params: TResetPass) =>
		axios.put("auth/forgot-password", params),
	// DaiDai - Auth
	authLogin: (params: TLoginParam) =>
		axios.post<TLoginRes>("auth/login", params),
	authCheckJwt: () => axios.get("auth/check-jwt"),
	// Blog
	postsAdd: (params: FormData) => axios.post("posts/posts-add", params),
	postsEdit: (params: FormData) => axios.post("posts/posts-edit", params),
	postsGet: (params: TPostsGet) => axios.get("posts/posts-get", { params }),
	postsRemove: (params: { pst_id: number }) =>
		axios.post("posts/posts-remove", params),
	usersGet: (params: TUsersGet) => axios.get("users/users-get", { params }),
	usersEdit: (params: FormData | TUsersEdit) =>
		axios.post("users/users-edit", params),
	usersAdd: (params: TUsersAdd) => axios.post("users/users-add", params),
	usersRemove: ({ usr_id: number }) =>
		axios.post("users/users-remove", { usr_id: number }),
	// tagsGet: (params: any) => axios.get("tags/tags-get", { params }),
	// tagsAdd: (params: { tag_label: string }) =>
	// 	axios.post("tags/tags-add", params),
	// tagsRemove: (params: { tag_id: number }) =>
	// 	axios.post("tags/tags-remove", params),
	tagsEdit: (params: { tag_id: number; tag_label: string }) =>
		axios.post("tags/tags-edit", params),

	/**
	 *
	 */

	categoriesGet: (params: TCategoriesGet) =>
		axios.get("categories/categories-get", { params }),
	categoriesTreeGet: (params: TCategoriesGet) =>
		axios.get("categories/categories-get-tree", { params }),
	categoriesRemove: (params: { cat_id: number }) =>
		axios.post("categories/categories-remove", params),
	categoriesEdit: (params: { cat_id: number; cat_name: string }) =>
		axios.post("categories/categories-edit", params),
	categoriesAdd: (params: { cat_name: string; cat_id_parent?: number }) =>
		axios.post("categories/categories-add", params),
	geoscopesGet: (params: { search?: string }) =>
		axios.get("geoscopes/geoscopes-get", { params }),
	geoscopesEdit: (params: { gsc_id: number; gsc_name: string }) =>
		axios.post("geoscopes/geoscopes-edit", params),
	geoscopesRemove: (params: { gsc_id: number }) =>
		axios.post("geoscopes/geoscopes-remove", params),
	geoscopesAdd: (params: { gsc_name: string }) =>
		axios.post("geoscopes/geoscopes-add", params),
	entitiesGet: (params: { search?: string; ent_id?: number }) =>
		axios.get("entities/entities-get", { params }),
	entitiesEdit: (params: { ent_id: number; ent_name?: string }) =>
		axios.post("entities/entities-edit", params),
	entitiesAdd: (params: { ent_name: string; ent_summary: string }) =>
		axios.post("entities/entities-add", params),
	entitiesRemove: (params: { ent_id: number }) =>
		axios.post("entities/entities-remove", params),
};
